import React from 'react';
import './tiles.css';
// interface TilesProps {
//     showChat: (show: boolean, name: string, text: string) => void; // Accept the setShowChat function as a prop
//     message?: any;
// }
const Tiles: React.FC = () => {
    // const replyHandler = async (name) => {
    //     let text = ""
    //     if (name === "summarize document") {
    //         text = "Tell me more about"
    //     } else if (name === "investment memo") {
    //         text = "Create investment memo for"
    //     }
    //     showChat(true, name, text);

    // }
    const companyLogo = "/chaticonlogo.png";
    return (
        <div className="tiles-container">
            <div className="loader">
                <img src={companyLogo} alt="Loading..." className="loader-logo" />
                <div className="help-text">
                    <h2>How can I help you today?</h2>
                </div>
            </div>
            {/* <div className="options">
                <div className="option" onClick={() => replyHandler("summarize document")}>
                    <h3>Tell me more about</h3>
                    <p>Please specify the bank name so we can assist you better.</p>
                </div>
                <div className="option" onClick={() => replyHandler("investment memo")}>
                    <h3>Investment Memo</h3>
                    <p>Generate a comprehensive investment memo.</p>
                </div>
                <div className="option" onClick={() => replyHandler("document research")}>
                    <h3>Document Research</h3>
                    <p>Search, summarize and compare documents.</p>
                </div>
            </div> */}
        </div>
    );
};

export default Tiles;